import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import type { CatalogRoleEntry } from '../../../services/iam';
import FilterDropdown from '../../filtering/FilterDropdown';

interface AccessUsersToolbarProps {
    search: string;
    onSearchChange: (value: string) => void;
    roles: readonly CatalogRoleEntry[];
    roleFilter: string[];
    onRoleFilterChange: (value: string[]) => void;
}

// Search box copied from UsersToolbar (Accounts > Users). Role filter uses
// the same FilterDropdown as billing/AccessRoutes; it's inherently multi-select
// but this filter stays single-valued (see AccessUsersList's `roleFilter[0]`).
export function AccessUsersToolbar({
    search,
    onSearchChange,
    roles,
    roleFilter,
    onRoleFilterChange
}: AccessUsersToolbarProps) {
    const roleOptions = roles.map((role) => ({ value: role.key, label: role.title }));

    return (
        <div className="flex items-center justify-between gap-4 shrink-0">
            <div className="flex items-center w-[340px] h-11 bg-white border border-gray-200 rounded-xl px-4 shrink-0">
                <MagnifyingGlassIcon className="w-5 h-5 text-gray-400 mr-2 shrink-0" />
                <input
                    type="text"
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Search users"
                    className="bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400 w-full"
                />
                {search && (
                    <button
                        type="button"
                        onClick={() => onSearchChange('')}
                        className="ml-2 shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Clear search"
                    >
                        <XMarkIcon className="w-4 h-4" />
                    </button>
                )}
            </div>
            <div className="flex items-center gap-2.5">
                <FilterDropdown
                    title="Role"
                    options={roleOptions}
                    selectedOptions={roleFilter}
                    onChange={onRoleFilterChange}
                    workQueueVariant
                    align="right"
                />
            </div>
        </div>
    );
}
